// extracted by mini-css-extract-plugin
export default {"values":"n68F4","gallery":"MnAFr","wrapper":"nV5yD","linkWrapper":"V7Q6a","selectedValue":"ISI8D","content":"xuao5"};